import { TabularCopySink } from './tabular.copysink';
import { IModel, IViolation } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { ImportExportSettings } from 'shell-models-lib';
import { Owned } from 'app/model/base/named';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { arrayIsNullOrEmpty } from 'app/registries/utls/util';
import { TeradataDataset } from 'app/model/dataset/teradata.dataset';

// TeradataSink can be only used in 2.0
@Metamodel.model({
    name: adfModelTypeMap.teradata.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(TeradataDataset) }
})
export class TeradataSink extends TabularCopySink {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        templatable: true,
        display: stringResources.ImportSettings_Label,
        constraint: {
            validator: TeradataSink.validateImportSettings
        }
    })
    public importSettings?: ImportExportSettings = Owned.create<ImportExportSettings>(ImportExportSettings.MODEL, this);

    private static validateImportSettings(copySink: TeradataSink, settings: ImportExportSettings): IViolation[] | undefined {
        const violations: IViolation[] = [];
        if (settings?.additionalFormatOptions?.length > 0) {
            const additionalFormatOptionsResult = createParameterConfigurationValidator(false, 'additionalFormatOptions')(settings, settings.additionalFormatOptions);
            if (!arrayIsNullOrEmpty(additionalFormatOptionsResult)) {
                violations.push(...additionalFormatOptionsResult);
            }
        }
        return violations;
    }
}